"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApListOrdered = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.ApListOrdered = function (_a) {
    var className = _a.className, children = _a.children, columnCount = _a.columnCount;
    return (React.createElement(styles_1.StyledListOrdered, { columnCount: columnCount, className: "ap-list-ordered " + (className ? className : '') }, children));
};
exports.ApListOrdered.defaultProps = {
    columnCount: 1
};
//# sourceMappingURL=ApListOrdered.js.map